import { render, staticRenderFns } from "./AdminMessage.vue?vue&type=template&id=75f8d259&scoped=true"
import script from "./AdminMessage.vue?vue&type=script&lang=js"
export * from "./AdminMessage.vue?vue&type=script&lang=js"
import style0 from "./AdminMessage.vue?vue&type=style&index=0&id=75f8d259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f8d259",
  null
  
)

export default component.exports